import { render, staticRenderFns } from "./tableDataRegistered.vue?vue&type=template&id=68af8a1c"
import script from "./tableDataRegistered.vue?vue&type=script&lang=js"
export * from "./tableDataRegistered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68af8a1c')) {
      api.createRecord('68af8a1c', component.options)
    } else {
      api.reload('68af8a1c', component.options)
    }
    module.hot.accept("./tableDataRegistered.vue?vue&type=template&id=68af8a1c", function () {
      api.rerender('68af8a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/sellers/components/tableDataRegistered.vue"
export default component.exports